import { toString } from "../../../lib/utils/string";
export const alertAtom = {
  id: 'uicore:alert',
  name: '弹出消息窗口',
  category: 'UI交互',
  paramsSchema: {
    type: 'object',
    fields: [{
      id: 'text',
      type: 'string',
      title: '文案',
      default: '请设置文案',
      ui: {
        settings: {
          multipleLine: true
        }
      }
    }]
  },
  execute: async (ctx, params) => {
    const uc = ctx.uc;
    await uc.$alert({
      content: toString(params.text)
    });
  },
  validateParams(ctxBase, params) {
    if (!params.text) return '文案不能为空';
  }
};
//# sourceMappingURL=alertAtom.js.map
